<div [ngClass]="['list-card-item-parent', color]" [class.outline]="outline" [class.clickable]="isClickable">
  <div [ngClass]="['list-card-item-content-parent', (imgSrc && 'hasThumbnail') || '']">
    <div *ngIf="imgSrc" class="content-list-item-thumbnail" [style.backgroundImage]="'url(' + imgSrc + ')'">
      <div class="play-icon-parent">
        <ion-icon *ngIf="isVideo" name="play" class="play-icon"></ion-icon>
      </div>
    </div>
    <ion-icon *ngIf="variant === 'icon' && icon && iconPosition === 'start'" [ngClass]="['list-card-item-icon', color]" [name]="icon"></ion-icon>
    <div [ngClass]="['list-card-item-count', color]" *ngIf="variant === 'count'">{{ count }}</div>
    <div style="display: flex; justify-content: center; flex-direction: column; width: 100%;">
      <div [ngClass]="['list-card-item-title', (imgSrc && 'hasThumbnail') || '']">
        {{ title }}
        <ion-chip (click)="disablePropagation($event)" *ngIf="syncStatus !== undefined" [id]="'sync-status' + identifier" [color]="syncStatus ? 'success' : 'warning'">
          <ion-icon class="syncStatus" [name]="syncStatus ? 'checkmark-circle-outline' : 'sync-circle-outline'"></ion-icon>
        </ion-chip>
        <div class="list-card-chevron-parent" *ngIf="iconPosition === 'top-align'">
          <ion-icon *ngIf="variant === 'icon' && icon" [ngClass]="['list-card-item-icon', color]" [name]="icon"></ion-icon>
          <ion-icon *ngIf="isClickable" class="list-card-item-chevron" name="chevron-forward"></ion-icon>
        </div>
      </div>
      <div [ngClass]="['list-card-item-content']" [class.single-line]="singleLine">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="list-card-chevron-parent" *ngIf="iconPosition !== 'top-align'">
    <ion-icon *ngIf="variant === 'icon' && icon && iconPosition === 'end'" [ngClass]="['list-card-item-icon', color]" [name]="icon"></ion-icon>
    <ion-icon *ngIf="isClickable" class="list-card-item-chevron" name="chevron-forward"></ion-icon>
  </div>
</div>
<div *ngIf="lines === 'show'" class="list-card-item-line"></div>

<div *ngIf="lines === 'full'" class="list-card-item-line list-card-item-lineFull"></div>

<ion-popover [trigger]="'sync-status' + identifier" triggerAction="click">
  <ng-template>
    <ion-content class="ion-padding">
      <ng-container *ngIf="syncStatus">
        Your data is synced to your provider.
      </ng-container>
      <ng-container *ngIf="!syncStatus">
        Your data is still syncing to your provider.
      </ng-container>
    </ion-content>
  </ng-template>
</ion-popover>
